import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AzureSearchRequest, AzureSearchService } from "@rubbl-azure-search";
import { EnvironmentConfig } from "@rubbl-core";
import { InventoryItem } from "@rubbl-inventory";

declare var environment: EnvironmentConfig;
@Component({
  selector: "app-no-search-results",
  templateUrl: "./no-search-results.component.html",
  styleUrls: ["./no-search-results.component.scss"],
})
export class NoSearchResultsComponent implements OnInit {
  baseImagePath: string;
  private azureSearchRequest = new AzureSearchRequest();
  similarResults: any[] = [];

  slidesPerViewConfig = {
    mobile: 1,
    tablet: 2,
    desktop: 2,
    "large-desktop": 3,
    "extra-large-desktop": 3,
    "extra-extra-large-desktop": 4,
  };

  constructor(private azureSearchService: AzureSearchService, private route: ActivatedRoute) {
    this.baseImagePath = environment.baseImagePath;
  }

  ngOnInit() {
    // not sure what to do here
    let searchTerm = this.route.snapshot.paramMap.get("model") || this.route.snapshot.queryParamMap.get("q");
    if (searchTerm == null) {
      return;
    }

    this.azureSearchRequest.search = searchTerm + "*";
    this.azureSearchRequest.filter = `status eq 'Available'`;
    this.azureSearchRequest.searchFields = "make,model,primaryType,account/name";
    this.azureSearchService.search<InventoryItem>(this.azureSearchRequest, "machines").subscribe(result => {
      for (const inventoryItem of result.value) {
        this.similarResults.push({ machine: inventoryItem });
      }
    });
  }
}
